/**
 * BLOCO DE DESCONTO PROGRESSIVO — Haustter
 * - id-swap: troca input[name="id"] para a variante do tier (add nativo do Minimog)
 * - properties[_image]: injeta a imagem do principal no line item do kit (carrinho)
 * - sincroniza o preco do topo: bloco custom .price-block-haustter (#custom-price-block)
 *   e, como fallback, o bloco nativo do Minimog (#Price-{section}) se existir.
 */
(function () {
  const block = document.querySelector('.progressive-discount-block');
  if (!block) return;

  const scope = block.closest('product-info') || document;
  const options = block.querySelectorAll('.pdb-option');
  const mainImage = block.dataset.mainImage || '';

  function setImageProp(form, value) {
    if (!form) return;
    let input = form.querySelector('input[name="properties[_image]"]');
    if (value) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_image]';
        form.appendChild(input);
      }
      input.value = value;
    } else if (input) {
      input.remove();
    }
  }

  function updateTopPrice(option) {
    const price = option.dataset.price || '';
    const compare = option.dataset.compare || '';
    const installment = option.dataset.installment || '';

    // Bloco de preco customizado da Haustter
    const custom = document.querySelector('#custom-price-block') || document.querySelector('.price-block-haustter');
    if (custom) {
      const cur = custom.querySelector('.current');
      const inst = custom.querySelector('.installments');
      let comp = custom.querySelector('.compare');
      if (cur) cur.textContent = price;
      if (inst && installment) inst.textContent = installment;
      if (compare) {
        if (comp) {
          comp.textContent = compare;
        } else if (cur) {
          comp = document.createElement('span');
          comp.className = 'compare';
          comp.textContent = compare;
          custom.insertBefore(comp, cur);
        }
      } else if (comp) {
        comp.remove();
      }
    }

    // Fallback: bloco de preco nativo do Minimog, se existir nesta pagina
    const mnm = scope.querySelector('[id^="Price-"]');
    if (mnm) {
      const curEl = option.querySelector('.pdb-option__price-current');
      const origEl = option.querySelector('.pdb-option__price-original');
      const curTxt = curEl ? curEl.textContent.trim() : price;
      const origTxt = origEl ? origEl.textContent.trim() : '';
      mnm.querySelectorAll('.m-price-item--sale').forEach(function (el) { el.textContent = curTxt; });
      mnm.querySelectorAll('.m-price__sale s.m-price-item--regular').forEach(function (el) { el.textContent = origTxt; });
      mnm.querySelectorAll('.m-price__regular .m-price-item--regular').forEach(function (el) { el.textContent = curTxt; });
    }
  }

  function applyTier(option) {
    const tier = option.dataset.tier;
    const variantId = block.dataset['tier' + tier + 'Variant'];
    if (!variantId) return;
    const isKit = tier !== '1';
    scope.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = variantId;
      setImageProp(input.form, isKit ? mainImage : '');
    });
    updateTopPrice(option);
  }

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      options.forEach(function (o) { o.classList.remove('pdb-option--selected'); });
      option.classList.add('pdb-option--selected');
      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      applyTier(option);
    });
  });

  const initial = block.querySelector('.pdb-option--selected') || options[0];
  if (initial) applyTier(initial);
})();
